import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Dropdown, DropdownDivider, DropdownHeader, DropdownItem, Navbar, NavbarBrand, NavbarCollapse, /*NavbarToggle,*/ NavbarLink, Avatar } from "flowbite-react";
import { useDispatch } from 'react-redux';
import { persistor } from '../../store';
import { logoutUser } from "../../services/callAPI/toLoginUser";
import UnvalidToast from "../toasts/UnvalidToast";
import { IUserInfo } from "../../services/interfaces/userInfo";
import { resetUser, updateNotifNumber, updateUserRole } from '../../store/userSlice';
import LinkMapping from "../../services/interfaces/LinkMapping";
import './ComponentNavbar.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { badgeIcons } from "../config/dictionnary/badges";
import { badgesToDisplay } from "../config/constants/badgesToDisplay";
import { clearTokens } from "../../services/hooks/storage/tokenStorage";
import { Capacitor } from "@capacitor/core";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useSocket } from "../../App";
import { getNotifs, markedNotifAsRead } from "../../services/callAPI/notifications";
import NotificationDropdown, { Tnotification } from "../notifications/NotificationDropdown";

interface IComponentNavbarProps {
  setIsShowHeader: (isShow: boolean) => void;
  userInfo: IUserInfo | null | undefined;
  setIsConnect: (isConnect: boolean) => void;
}

export function ComponentNavbar(props: IComponentNavbarProps) {
  //destructuring
  const { /*setIsShowHeader,*/ userInfo, /*setIsConnect*/ } = props;
  const socket = useSocket();

  const isNative = Capacitor.isNativePlatform();

  const isDev = import.meta.env.DEV;
  const isProd = import.meta.env.PROD;
  const isTraveler = userInfo?.role === "TRAVELER";
  let href = "#";

  if (isDev) {
    href = isTraveler ? "http://localhost:5173/trade_requests" : "http://localhost:5173/trade_propositions";
  } else if (isProd) {
    href = isTraveler ? "https://cemade.fr/trade_requests" : "https://cemade.fr/trade_propositions";
  } else {
    href = "#"
  }

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const mainLink = userInfo?.role === "TRAVELER" ? "/trade_requests" : "/trade_propositions";

  const [isShowUnValidToast, setIsShowUnValidToast] = useState<boolean>(false);
  const [activeLink, setActiveLink] = useState<string>(mainLink);
  const [/*isShowBurguer*/, setisShowBurguer] = useState<boolean | undefined>(undefined);
  const [sizeAvatar, setsizeAvatar] = useState<string | undefined>("lg");
  const [nbrNotif, setnbrNotif] = useState<number | null>();
  const [listNotif, setlistNotif] = useState<Tnotification[]>([]);
  const [showNotifList, setShowNotifList] = useState(false);

  const resetAppState = async () => {
    await clearTokens();
    dispatch(resetUser()); //reset redux's user state
    await persistor.purge(); //delete data into localstorage stock by redux persistor
    localStorage.removeItem("persist:root"); //delete key into localstorage who stock redux's user slice
  };

  const handleLogout = async () => {
    try {
      // 🔌 Nettoyage total du socket
      if (socket) {
        socket.off(); // retire tous les listeners
        socket.disconnect(); // coupe la connexion
      }

      const response = await logoutUser();
      if (response.status === 204) {
        await resetAppState();

        window.location.href = '/';

      } else {
        throw new Error('erreur');
      }
    } catch (error) {
      await resetAppState();
      window.location.href = '/';
    }
  };

  // Fonction pour ajuster le colspan en fonction de la taille de l'écran
  const handleShowBurguerMenu = () => {
    if (window.innerWidth >= 768) {
      setisShowBurguer(false);
    } else {
      setisShowBurguer(true);
    }
  };

  // Fonction pour resize l'avatar
  const handleResizeAvatar = () => {
    if (window.innerWidth <= 767) {
      setsizeAvatar("md");
    } else {
      setsizeAvatar("lg");
    }
  }

  useEffect(() => {
    if (userInfo && userInfo.role) {
      dispatch(updateUserRole(userInfo.role));
    }

    if (userInfo && userInfo.notifNumber) {
      dispatch(updateNotifNumber(userInfo.notifNumber));
    }
  }, [dispatch])

  //surbrillance du lien lorsque le user est sur la page
  const linkMapping: LinkMapping = {
    "/trade_requests": "demandes",
    "/trade_propositions": "propositions",
    "/my_trocs": "trocs",
    "/search_trocs": "search",
  }

  // usEffect to define active link 
  useEffect(() => {
    // On affirme que location.pathname est bien une clé valide de LinkMapping
    const link = linkMapping[location.pathname as keyof LinkMapping];

    // Si le lien existe, on met à jour activeLink
    if (link) {
      setActiveLink(link);
    }
  }, [location.pathname]);

  // Utilisation de useEffect pour gérer le redimensionnement de la fenêtre
  useEffect(() => {
    // Appeler les fonctions lors du montage initial du composant
    handleShowBurguerMenu();
    handleResizeAvatar();

    // Ajouter un écouteur d'événements pour montrer ou pas le menu burguer
    window.addEventListener('resize', handleShowBurguerMenu);

    // Ajouter un écouteur d'événements pour redimensionner l'avatar
    window.addEventListener('resize', handleResizeAvatar);

    // Nettoyer l'écouteur d'événements lors du démontage du composant
    return () => {
      window.removeEventListener('resize', handleShowBurguerMenu);
      window.addEventListener('resize', handleResizeAvatar);
    };
  }, []); // Le tableau vide assure que cela ne s'exécute qu'une seule fois au montage

  //Direction vers la page profil
  const RedirectToProfil = () => {
    navigate('/profil');
  };

  const redirectToSubscriptionPage = () => {
    //redirect  to subscriptionPage
    navigate('/manage-my-subscription');
  };

  const handleNotifReceive = (notif: { id: number | undefined; notif_nature: string; message: string; isRead: boolean; }) => {
    //update notif list
    setlistNotif((prev) => [
      notif,
      ...prev
    ]);

    //update notif nbr
    setnbrNotif((prev) => (prev ?? 0) + 1);

    // Ajout classe animée à la cloche
    const notifIcon = document.getElementById('div-notif');
    if (notifIcon) {
      notifIcon.classList.add('animate-shake');

      // Supprime l'animation après 500ms pour pouvoir la rejouer plus tard
      setTimeout(() => {
        notifIcon.classList.remove('animate-shake');
      }, 500);
    }
  }

  //useEffet to get notif
  useEffect(() => {
    if (!socket) return;

    const handleGetNotif = async () => {
      try {
        //call api
        const response = await getNotifs();

        switch (response.status) {
          case 200:
            const notifNoRead: Tnotification[] = response.data.filter((notif: Tnotification) => notif.isRead === false)
            setnbrNotif(notifNoRead.length);
            setlistNotif(response.data);
            break;
          case 204:
            setnbrNotif(null);
            break;
          default:
            null;
        }
      } catch (error) {
        console.error(`Erreur lors la récup du nbrNotif: ${error}`);
        null;
      }
    }

    handleGetNotif();

    //🔔 écoute la réception d'une notif en live
    socket?.on("receiveNotificationTroc", handleNotifReceive);

    return () => {
      socket?.off("receiveNotificationTroc", handleNotifReceive);
    };
  }, [socket])

  function handleMarkedNotifAsRead() {
    if (nbrNotif != null && nbrNotif != 0) {
      //call api
      markedNotifAsRead();
    }
  }

  return (
    <Navbar fluid className="bg-greenCustom rounded-2xl">
      {/* logo */}
      <NavbarBrand as={NavLink} to={!isNative ? href : null}>
        <img src="/logo-cemade.png" className="mr-3 sm:h-10" style={{ height: '3rem', width: 'auto' }} alt="Logo cemade" />
        <span id="span-logo-cemade" className="self-center whitespace-nowrap text-xl font-semibold dark:text-white text-orangeCustom">CEMADE</span>
      </NavbarBrand>

      {/* avatar and notif */}
      <div className="flex md:order-2 gap-1">
        <div
          id="div-notif"
          className="mr-3 relative cursor-pointer flex justify-center items-center"
          onClick={() => {
            if (nbrNotif != null && nbrNotif > 0) setnbrNotif(0);
            setShowNotifList(!showNotifList);
            handleMarkedNotifAsRead();
          }}
        >
          {/* Cloche */}
          <FontAwesomeIcon icon={faBell} size="xl" color="#E09F3E" />

          {/* circle nbr notif */}
          {
            nbrNotif != null && nbrNotif > 0 && (
              <div className="absolute top-5 -right-3 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow">
                {nbrNotif}
              </div>
            )
          }
        </div>

        {/* notif dropdown */}
        {showNotifList && (
          <div id="div-notif-dropdown" className="relative">
            <NotificationDropdown listNotif={listNotif} onClose={() => setShowNotifList(false)} setlistNotif={setlistNotif} />
          </div>
        )}

        {/* <NavbarToggle type="button" id="navbarToggle" className={`${isShowBurguer ? "" : "hidden"} border-none`} /> */}
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <div className="relative">
              <Avatar
                alt="User settings"
                img={userInfo?.role === "TRAVELER" ? "avatar-trav.jpg" : "avatar-res.svg"}
                rounded
                size={sizeAvatar}
              />

              {/* Affichage de plusieurs badges si présents */}
              {Array.isArray(userInfo?.badges) && userInfo.badges.length > 0 && (
                <div className="absolute -bottom-1 -right-1">
                  {(() => {
                    // On cherche le badge le plus prioritaire que possède l'utilisateur
                    const prioritizedBadge = badgesToDisplay.find((badge) =>
                      userInfo.badges.includes(badge)
                    );

                    // Affichage si un badge valide est trouvé et a une icône définie
                    return (
                      prioritizedBadge &&
                      badgeIcons[prioritizedBadge] && (
                        <FontAwesomeIcon
                          icon={badgeIcons[prioritizedBadge]}
                          title={prioritizedBadge}
                          className="text-lightRedCustom bg-orangeCustom rounded-full p-1 text-xs shadow"
                        />
                      )
                    );
                  })()}
                </div>
              )}
            </div>
          }
        >
          <DropdownHeader>
            <span className="block text-sm">{userInfo?.pseudo}</span>
            <span className="block truncate text-sm font-medium text-orangeCustom">{userInfo?.role === "TRAVELER" ? "voyageur" : "résident"}</span>
          </DropdownHeader>
          <DropdownItem className="hover:bg-gradient-to-b hover:from-gray-300 hover:to-gray-100" onClick={() => RedirectToProfil()}>Profil</DropdownItem>
          <DropdownItem className="hover:bg-gradient-to-b hover:from-gray-300 hover:to-gray-100" onClick={() => redirectToSubscriptionPage()}>Abonnement</DropdownItem>
          <DropdownItem className="hover:bg-gradient-to-b hover:from-gray-300 hover:to-gray-100" onClick={() => navigate("/mentions-legales")}>Mentions légales</DropdownItem>
          <DropdownDivider />
          <DropdownItem className="hover:bg-gradient-to-b hover:from-gray-300 hover:to-gray-100" onClick={handleLogout}>Déconnexion</DropdownItem>
        </Dropdown>
      </div>

      {/* Navbar Links */}
      <NavbarCollapse id="navbar-collapse">
        <NavbarLink as={NavLink} to={mainLink} className={`text-white text-start hover:bg-greenCustom hover:text-orangeCustom ${activeLink === "demandes" || activeLink === "propositions" ? "text-orangeCustom" : null}`} >
          {userInfo?.role === "TRAVELER" ? "Mes demandes de trocs" : "Mes propositions reçues"}
        </NavbarLink>
        <NavbarLink as={NavLink} to={"/my_trocs"} className={`text-white text-start hover:bg-greenCustom hover:text-orangeCustom ${activeLink === "trocs" ? "text-orangeCustom" : null}`} >
          Mes éléments d'échange
        </NavbarLink>
        <NavbarLink as={NavLink} to={"/search_trocs"} className={`text-white text-start hover:bg-greenCustom hover:text-orangeCustom ${activeLink === "search" ? "text-orangeCustom" : null}`} >
          Chercher un partenaire de troc
        </NavbarLink>
      </NavbarCollapse>

      {isShowUnValidToast ? <UnvalidToast onClose={() => setIsShowUnValidToast(false)} /> : null}
    </Navbar>

  );
}
export default ComponentNavbar;